import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Meta } from '@angular/platform-browser';
import { TrxService, ZipYiService } from '~services';
import { ZipYiContext } from '~services/biocatch/zip-yi-context.enum';

@Component({
  selector: 'app-error-unavailable-view',
  templateUrl: './error-unavailable.component.html',
  styleUrls: ['./error-unavailable.component.scss', '../../../../scss/error.styling.scss'],
  standalone: false,
})
export class ErrorUnavailableViewComponent implements OnInit {
  appPrefix = environment.appPrefix;

  constructor(
    private metaService: Meta,
    private zipYiService: ZipYiService,
    private trxService: TrxService,
  ) {
    this.addTag();
  }

  ngOnInit(): void {
    this.zipYiService.setContext(ZipYiContext.UnavailableErrorPage);
    this.trxService.sectionFailedEvent();
    window.zbm?.markAsErrorPage(500, 'Unavailable');
  }

  addTag() {
    this.metaService.addTag({ name: 'robots', content: 'noindex' });
  }
}
